/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import Image from "react-bootstrap/Image";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { APP_COLORS } from "../../../common/Constants";
import { faCheck, faQuestion } from "@fortawesome/pro-solid-svg-icons";
import { CompanyDetailText, ContactContainer, ContactInfo, ContactNameInfo } from "../Company";

import ContactIcon from "../../../common/assets/img/ToolbeltIcons-16.png";

const ContactSection = (props) => {
    const {
        contactName,
        contactPhone,
        contactEmail,
        contactTitle,
        contactEmailStatus
    } = props;

    return (
        <ContactItemRow
            contactName={contactName}
            contactPhone={contactPhone}
            contactEmail={contactEmail}
            contactTitle={contactTitle}
            contactEmailStatus={contactEmailStatus}
        />
    )
}

export default ContactSection;

const ContactItemRow = (props) => {
    return (
        <ContactContainer>
            <ContactNameInfo>
                <Image
                    className="contact-icon"
                    src={ContactIcon}
                    alt="ToolBeltData Contact Icon"
                    fluid
                    width={80}
                />
                <div style={{ paddingTop: 10 }}>
                    <CompanyDetailText fontSize={17}>{props.contactName}</CompanyDetailText>
                    <CompanyDetailText fontSize={14}>{props.contactTitle}</CompanyDetailText>
                </div>
            </ContactNameInfo>
            <ContactInfo>
                <CompanyDetailText fontSize={14}>{props.contactPhone}</CompanyDetailText>
                <CompanyDetailText fontSize={14}>
                    {props.contactEmail}
                    <span style={{marginLeft: 10}}>
                        {props.contactEmailStatus && props.contactEmailStatus === "Verified" && (
                            <FontAwesomeIcon
                                color={APP_COLORS['green']}
                                icon={faCheck}
                            />
                        )}
                        {props.contactEmailStatus && props.contactEmailStatus !== "Verified" && (
                            <FontAwesomeIcon
                                color={APP_COLORS['yellow']}
                                icon={faQuestion}
                            />
                        )}
                    </span>
                </CompanyDetailText>
            </ContactInfo>
        </ContactContainer>
    )
}
